import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/orders/default'),
  },
  {
    path: '/order/:id',
    name: 'orderDetail',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/orders/detail'),
  },
  {
    path: '/print/:id',
    name: 'orderPrint',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/orders/print'),
  },
  {
    path: '/hbcod',
    name: 'hbcod',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/hbcod/default'),
  },
  {
    path: '/hbcod/add',
    name: 'hbcodAdd',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/hbcod/add'),
  },
  {
    path: '/hbcod/:id',
    name: 'hbcodDetail',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/hbcod/detail'),
  },
  {
    path: '/hbpos',
    name: 'hbpos',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/hbpos/default'),
  },
  {
    path: '/hbpos/add',
    name: 'hbposAdd',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/hbpos/add'),
  },
  {
    path: '/hbpos/:id',
    name: 'hbposDetail',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/hbpos/detail'),
  },
  {
    path: '/eorder',
    name: 'eorder',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/ecommerce-platform/default'),
  },
  {
    path: '/sale',
    name: 'sale',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/sale/default'),
  },
  {
    path: '/session',
    name: 'session',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/session/default'),
  },
  {
    path: '/session/:id',
    name: 'sessionDetail',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/session/detail'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/404').default,
  },
  {
    path: '*',
    redirect: '404',
  },
  
]
